<template>
    <SOSlotModal :modal-title="pageSetting.modal.title" :modal-id="pageSetting.modal.id" @close="close">
        <template v-slot:modal-body>
            <div class="f-regular f-16 f-c-black p-t-16">
                Yakin ingin menghapus template
                <b>{{ getTemplateName }}</b> ?
            </div>
        </template>
        <template v-slot:modal-footer>
            <SOButton
                class="m-0 p-d-12"
                :text="'Ya, hapus template'"
                :outline-danger="true"
                :full="true"
                :disable="isFetching"
                :loading="isFetching"
                @action="doDeteletTemplate"
            />
            <SOButton
                class="m-0"
                :text="'Batal'"
                :outline="true"
                :full="true"
                :disable="isFetching"
                :loading="isFetching"
                @action="close"
            />
        </template>
    </SOSlotModal>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { moduleName } from "./../../store/state";
import SOSlotModal from "@/so-components/global/slot/SOSlotModal";
import SOButton from "@/so-components/global/ui/SOButton";
import resulter from "@/store/utils/resulter";

export default {
    name: "ModalHapusTemplatePesan",
    components: {
        SOSlotModal,
        SOButton,
    },
    computed: {
        ...mapGetters(moduleName, {
            isFetching: "isFetching",
        }),
        getLastId() {
            return this.endItemofPage.id ? `card-${this.endItemofPage.id}` : "";
        },
        getTemplateName() {
            return this.$route.query.data?.nama || "";
        },
    },
    data() {
        return {
            id: "",
            pageSetting: {
                modal: {
                    title: "Hapus template",
                    id: "modal-hapus-template-pesan",
                },
            },
        };
    },
    mounted() {
        $("#" + this.pageSetting.modal.id).modal("show");
        this.id = this.$route.params.id;
    },
    methods: {
        ...mapActions({
            deleteTemplate: `${moduleName}/deleteTemplate`,
            fetchListTemplate: `${moduleName}/fetchListTemplate`,
            resetListTemplate: `${moduleName}/resetListTemplate`,
            setResponse: `${moduleName}/setResponse`,
            setFetching: `${moduleName}/setFetching`,
        }),
        doDeteletTemplate() {
            this.deleteTemplate(this.id)
                .then((response) => {
                    let { code, status, msg, data } = response.data;

                    if (status && code === 200) {
                        this.$toast.success(msg);
                        this.resetListTemplate();
                        this.fetchListTemplate();
                        this.close();
                    } else {
                        this.setResponse(resulter.errorResult(msg));
                        this.$toast.error(msg);
                    }
                })
                .catch((e) => {
                    this.setFetching(false);
                    this.$toast.error(e);
                    this.setResponse(resulter.errorResult(e));
                });
        },
        close() {
            if (this.$route.query.list !== undefined) {
                this.$route.query.list ? this.$router.go(-3) : this.$router.back();
            } else {
                this.$router.back();
            }
        },
    },
};
</script>
